import { defineMessages } from 'react-intl';

export default defineMessages({
  next: 'Next Thread',
  previous: 'Prev Thread',
  title: 'Message Boards'
});
